<div class="container main-container">
    <div class="alert alert-danger">
        <h2 class="text-danger">Acesso Negado!</h2>
    </div>
</div>